/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportDto } from '../../models/import-dto';
import { ImportTarRequest } from '../../models/import-tar-request';

export interface ImportFromTar$Params {
      body: ImportTarRequest
}

export function importFromTar(http: HttpClient, rootUrl: string, params: ImportFromTar$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportDto>> {
  const rb = new RequestBuilder(rootUrl, importFromTar.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportDto>;
    })
  );
}

importFromTar.PATH = '/v0/supervisely';
